import { useEffect, useState } from 'react'
import { httpsCallable, getFunctions } from 'firebase/functions'

const MIN_LOAD_MS = 5000

const useUserRole = (user) => {
  const [role, setRole] = useState(null)
  const [customer, setCustomer] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    if (!user) {
      setRole(null)
      setCustomer(null)
      setLoading(false)
      return
    }

    const fetchRole = async () => {
      setLoading(true)
      const start = Date.now()

      let resolvedRole = null
      let resolvedCustomer = null

      // Resolve admin role locally for @inspireht.com emails
      if (user.email && user.email.endsWith('@inspireht.com')) {
        resolvedRole = 'admin'
      } else {
        try {
          const getCustomerByEmail = httpsCallable(getFunctions(), 'getCustomerByEmail')
          const res = await getCustomerByEmail({ email: user.email })
          const data = res.data

          if (data && data.role) {
            resolvedRole = data.role
            resolvedCustomer = data.customer || null
          }
        } catch (error) {
          console.error('Error resolving user role:', error)
        }
      }

      // Ensure minimum load time so the UI doesn't flash
      const elapsed = Date.now() - start
      if (elapsed < MIN_LOAD_MS) {
        await new Promise((resolve) => setTimeout(resolve, MIN_LOAD_MS - elapsed))
      }

      setRole(resolvedRole)
      setCustomer(resolvedCustomer)
      setLoading(false)
    }

    fetchRole()
  }, [user])

  return { role, customer, loading }
}

export default useUserRole
